import { createContext } from 'react'

export const ApplicationContext = createContext({
  user: {}
})

export default ApplicationContext